// extracted by mini-css-extract-plugin
export var container = "_o-1";
export var copyright = "_o-3";
export var footer = "_o-0";
export var logo = "_o-2";